import WhatsNewIndex from './WhatsNewIndex'

export default WhatsNewIndex
